import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    BasicSocialConsultingGridObject,
} from '@libs/types/src/services/object-type/basic-social-consulting/basic-social-consulting.object';
import { filterFrag } from './types/filter.types';
import {
    BasicSocialConsultingCreateInput,
} from '@libs/types/src/services/input-type/basic-social-consulting/basic-social-consulting.create-input';
import { OkObject } from '@it2go/types';
import {
    BasicSocialConsultingUpdateInput,
} from '@libs/types/src/services/input-type/basic-social-consulting/basic-social-consulting.update-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import {
    BasicSocialConsultingTagGridObject,
} from '@libs/types/src/services/object-type/basic-social-consulting/basic-social-consulting-tag.object';
import {
    BasicSocialConsultingYearCountsObject,
} from '@libs/types/src/services/object-type/basic-social-consulting/basic-social-consulting-year-counts.object';

@Injectable({ providedIn: 'root' })
export class BasicSocialConsultingGqlService extends GqlServiceV2 {

    public async getBasicSocialConsulting(input: GridInput | null, frag: string) {
        return this.query<BasicSocialConsultingGridObject>(
            `
                query($input: GridInput) {
                    basicSocialConsulting {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async createBasicSocialConsulting(input: BasicSocialConsultingCreateInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: BasicSocialConsultingCreateInput!) {
                    basicSocialConsulting {
                        create(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        )
    }

    public async updateBasicSocialConsulting(input: BasicSocialConsultingUpdateInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: BasicSocialConsultingUpdateInput!) {
                    basicSocialConsulting {
                        update(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        )
    }

    public async deleteBasicSocialConsulting(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    basicSocialConsulting {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        )
    }

    public async getBasicSocialConsultingYearCounts(input: IdInput) {
        return this.query<BasicSocialConsultingYearCountsObject>(
            `
                query($input: IdInput!) {
                    basicSocialConsulting {
                        yearCounts(input: $input) {
                            thisYear
                            lastYear
                            all
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getBasicSocialConsultingTags(input: GridInput, frag: string) {
        return this.query<BasicSocialConsultingTagGridObject>(
            `
                query($input: GridInput) {
                    basicSocialConsultingTag {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async getBasicSocialConsultingServiceTags(input: IdInput) {
        return this.query<string[]>(
            `
                query($input: IdInput!) {
                    basicSocialConsultingTag {
                        serviceTags (input: $input)
                    }
                }
            `,
            { input },
        );
    }
}
